import React, { useState } from 'react';
import { Form, Button, Container, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { registerAuth } from '../reducers/AuthSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';


function Register() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const response = dispatch(registerAuth(formData));
        if (response) {
            toast.success('Registration successful!');
            navigate('/Sign-in');
        }
    };

    return (
        <Container fluid className="auth-container">
            <Row className="h-100">
                <Col className="right w-50 d-flex justify-content-center align-items-center">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="my-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                placeholder="Enter Username..."
                            />
                        </Form.Group>
                        <Form.Group className="my-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter Email..."
                            />
                        </Form.Group>
                        <Form.Group className="my-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter Password..."
                            />
                        </Form.Group>
                        <div class="d-flex justify-content-center">
                            <Button
                                type="submit"
                                variant="dark"
                                className="my-3"
                                disabled={loading}
                                style={{ width: '130px' }}
                            >
                                {loading ? (
                                    <span>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Loading...
                                    </span>
                                ) : (
                                    'Sign In'
                                )}
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default Register;
